import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ButtonV2, Link } from '@zola/zola-ui';
import DragAndDrop from '../../../util/DragAndDrop';

import ZolaColumnList from './ZolaColumnList';
import UserColumnList from './UserColumnList';
import { trackUpdateGuestListStep } from '../../../../util/trackingHelper';

import featureFlag from '../../../../util/featureFlags';

const isSpreadsheetUploadTracking = featureFlag.get('isSpreadsheetUploadTracking');

const ListMapper = ({
  addExtraField,
  busy,
  endMapping,
  fields,
  onUpdateGuestList,
  mapZolaColumn,
  unmapZolaColumn,
  flowRunId,
}) => {
  const {
    extraFields,
    userFields,
    zolaFields
  } = fields;
  const [maxHeight, setMaxHeight] = useState('auto');

  return (
    <div className="mapping-container">
      <DragAndDrop>
        <div className="column-container">
          <ZolaColumnList
            addExtraField={addExtraField}
            extras={extraFields}
            fields={zolaFields}
            maxHeight={maxHeight}
            unmapZolaColumn={unmapZolaColumn}
          />
          <UserColumnList
            fields={userFields}
            mapZolaColumn={mapZolaColumn}
            unmapZolaColumn={unmapZolaColumn}
            setHeight={setMaxHeight}
          >
            <div className="button-container">
              <Link
                role="button"
                onClick={() => {
                  endMapping();
                  if (isSpreadsheetUploadTracking) trackUpdateGuestListStep('cancel', flowRunId);
                }}
                className="button--cancel-mapping"
              >
                Cancel
              </Link>
              <ButtonV2 onClick={onUpdateGuestList} disabled={busy}>Update Guest List</ButtonV2>
            </div>
          </UserColumnList>
        </div>
      </DragAndDrop>
    </div>
  )
};

ListMapper.propTypes = {
  addExtraField: PropTypes.func,
  busy: PropTypes.bool,
  endMapping: PropTypes.func,
  fields: PropTypes.shape({
    requiredFields: PropTypes.arrayOf(PropTypes.string),
    userFields: PropTypes.objectOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      target: PropTypes.string
    })),
    zolaFields: PropTypes.objectOf(PropTypes.shape({
      name: PropTypes.string,
      assigned: PropTypes.bool
    })),
    extraFields: PropTypes.arrayOf(PropTypes.string)
  }),
  onUpdateGuestList: PropTypes.func,
  mapZolaColumn: PropTypes.func,
  unmapZolaColumn: PropTypes.func,
  flowRunId: PropTypes.string,
};

export default ListMapper;



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/upload/ListMapper.jsx